import React from "react";

import FilterChip from "js/components/Dashboard/FilterChip";

type InvestigationFilters = {
  is_active?: string;
  status?: "created" | "in_progress" | "completed" | "invalid";
  legal_type?: "natural" | "legal";
};

interface InvestigationFiltersProps {
  onFilterChange: (filters: InvestigationFilters) => void;
  filters: InvestigationFilters;
}

const InvestigationFilters: React.FC<InvestigationFiltersProps> = ({
  onFilterChange,
  filters,
}) => {
  const handleFilterChange = (
    key: keyof InvestigationFilters,
    value?: string,
  ) => {
    const newFilters: InvestigationFilters = { ...filters };
    if (value == null || value === "") {
      delete newFilters[key];
    } else {
      newFilters[key] = value as InvestigationFilters[typeof key];
    }
    onFilterChange(newFilters);
  };

  return (
    <div className="flex flex-wrap gap-2">
      <FilterChip
        label="Estado"
        value={filters.is_active}
        onChange={(value) => handleFilterChange("is_active", value)}
        options={[
          { label: "Activo", value: "true" },
          { label: "Inactivo", value: "false" },
        ]}
      />

      <FilterChip
        label="Fase"
        value={filters.status}
        onChange={(value) => handleFilterChange("status", value)}
        options={[
          { label: "Creado", value: "created" },
          { label: "En progreso", value: "in_progress" },
          { label: "Completado", value: "completed" },
          { label: "Inválido", value: "invalid" },
        ]}
      />

      <FilterChip
        label="Tipo"
        value={filters.legal_type}
        onChange={(value) => handleFilterChange("legal_type", value)}
        options={[
          { label: "Persona Física", value: "natural" },
          { label: "Persona Moral", value: "legal" },
        ]}
      />
    </div>
  );
};

export default InvestigationFilters;
